import { Chart } from 'primereact/chart';
import React, { useEffect, useState } from 'react';

interface Props {
    metricName?: string;
    graphData: any[];
    labels: string[];
}

export const ScorecardAgingGraph = ({ graphData, metricName, labels }: Props) => {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const data = {
            labels,
            datasets: [
                {
                    label: '',
                    backgroundColor: [
                        'rgba(255, 136, 136, 1)',
                        'rgba(255, 229, 195, 1)',
                        'rgba(255, 253, 193, 1)',
                        'rgba(189, 239, 255, 1)',
                    ],
                    data: graphData,
                    showLine: true,
                },
            ],
        };
        const options = {
            maintainAspectRatio: false,
            //aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        fontColor: textColor,
                        usePointStyle: true,
                    },
                    display: true,
                    position: 'bottom',
                },
                title: {
                    display: true,
                    text: metricName,
                },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, [graphData, labels, metricName]);

    if (graphData?.length === 0) {
        return (
            <div className="card border-0 w-100">
                <div className="card-body align-middle text-center">
                    <div className="row" style={{ height: '170px' }}>
                        <div className="col-md-12" style={{ margin: 'auto' }}>
                            <p className="align-middle">No Data Found</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Chart
            style={{
                height: '300px',
            }}
            type="pie"
            data={chartData}
            options={chartOptions}
        />
    );
};
